module.exports = __webpack_public_path__ + "static/media/cloudyt.95d193cd.png";